import type { AxiosError } from "axios";
import { getApiErrorMessage, getRawApiErrorMessage } from "./getApiErrorMessage";

export type ApiErrUser = {
  uid?: number | null;
  sub?: string | null;
};

type ErrMeta = {
  reqUrl: string;
  status: string;
  pageUrl: string;
  at: string;
  user: string;
  msg: string;
};

const fmtTime = (d = new Date()): string =>
  d.toLocaleString("ru-RU", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
  });

const pickUser = (u?: ApiErrUser | null): string => {
  if (!u) return "—";
  if (u.uid != null) return String(u.uid);
  if (u.sub?.trim()) return u.sub.trim();
  return "—";
};

const pickReqUrl = (err: AxiosError): string => {
  const cfg = err.config;
  if (!cfg) return "—";
  const base = cfg.baseURL ?? "";
  const path = cfg.url ?? "";
  try {
    if (/^https?:\/\//i.test(path)) return path;
    if (base) return new URL(path || "", base).toString();
  } catch {
    return `${base}${path}` || "—";
  }
  return `${base}${path}` || "—";
};

const pickStatus = (err: AxiosError): string => {
  const code = err.response?.status;
  if (code != null) return String(code);
  if (err.code) return err.code;
  return "—";
};

export const buildApiErrMeta = (
  err: AxiosError,
  user?: ApiErrUser | null
): ErrMeta => ({
  reqUrl: pickReqUrl(err),
  status: pickStatus(err),
  pageUrl: typeof window !== "undefined" ? window.location.href : "—",
  at: fmtTime(),
  user: pickUser(user),
  msg: getApiErrorMessage(err, getRawApiErrorMessage(err) || "Неизвестная ошибка"),
});

export const buildApiErrCopyText = (m: ErrMeta): string =>
  [
    `Сообщение: ${m.msg}`,
    `URL запроса: ${m.reqUrl}`,
    `Статус: ${m.status}`,
    `URL страницы: ${m.pageUrl}`,
    `Время: ${m.at}`,
    `Пользователь: ${m.user}`,
  ].join("\n");

export const API_ERR_TOAST_MS = 30_000;
